import { ConfigurablePropsFromDescription } from "../../../helpers/widget"
import PublishUtils from "../../../helpers/PublishUtils"

export const configOptions = [
  {
    name: 'ifcUrls',
    type: 'text',
    label: 'IFC URLs to load and view (not the UploadAnyFile URI)',
    topicValueInterpolationEnabled: true
  },
  {
    name: 'fragUrls',
    type: 'text',
    label: 'Fragment URLs to load and view (not the UploadAnyFile URI)',
    topicValueInterpolationEnabled: true
  },
  {
    name: 'autoConvertToFrag',
    type: 'boolean',
    label: 'Automatically convert any IFCs that are loaded to Frag files',
    topicValueInterpolationEnabled: true
  },
  PublishUtils.getMultipleValueFormatOptions(),
  PublishUtils.getTimestampParametersDef()
] as const

export type IFCViewerV4ConfigOptions = ConfigurablePropsFromDescription<typeof configOptions>
